import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const NativeModules: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://reactnative.dev/docs/native-modules-intro'>
          Native Modules
        </a>
      </h1>
      <p className='text-justify'>
        A la hora de trabajar con react native, una de las principales ventajas
        que hay que tener en cuenta (respecto de otros frameworks como ionic que
        nos habilitan web views), es que tenemos acceso completo a las funciones
        nativas del sistema operativo del dispositivo donde nuestra aplicación
        esté corriendo. Todo esto con la simplificación que trae poder compartir
        una gran cantidad del código base.
      </p>
      <p className='text-justify'>
        Pero para efectivamente hacer uso de eso necesitamos entender de{" "}
        <i>
          <strong>Native Modules</strong>
        </i>
        .
      </p>
      <div className='alert alert-warning mt-2' role='alert'>
        React Native viene preparando una actualización de los módulos nativos
        hace bastante tiempo. Se llaman{" "}
        <a href='https://github.com/react-native-community/discussions-and-proposals/issues/40'>
          Turbo Modules
        </a>{" "}
        y hay que estar atento a esto porque potencialmente introduciría
        simplificaciones y mayores capacidades a esto que se desarrolla en esta
        página.
      </div>
      <p>
        Básicamente, NativeModules es una abstracción que ofrece React Native
        para que cualquiera pueda incrustar prográmas escritos en código nativo
        al famoso{" "}
        <a href='https://dev.to/wjimmycook/how-the-react-native-bridge-works-and-how-it-will-change-in-the-near-future-4ekc'>
          bridge
        </a>{" "}
        de react native (el cual nos permitirá posteriormente comunicarnos con
        el lado de JavaScript).
      </p>
      <h2>¿Es muy dificil?</h2>
      <p>
        No, por lo menos para componentes funcionales (modulos que se rendericen
        son más complicados). En esencia tenés que hacer una clase que erede de
        un modulo nativo de react native y que implemente los métodos que tenga
        que implementar. En normas generales tenes que entender que es todo
        asincrónico así que más que nada vas a trabajar con promesas.
      </p>
      <h2>¿Cuando usarlo?</h2>
      <p>
        Esto no es para usarlo en cualquier boludez. Hay que tener en cuenta que
        todo lo que se haga como NativeModule debe ser programado dos veces.
        Cosas que se puedan hacer con los componentes que ya te de react native
        deben hacerse usando eso. Pero si vienen muy bien para programar modulos
        para usar el bluetooth, alguna api interna de machine learning del
        sistema operativo, o alguna api que permita usar el calendario,
        geocoding, librerías nativas de tercero, etc.
      </p>
      <h2>¿Donde puedo ver un ejemplo en Crombie?</h2>
      <p>
        Usando módulos nativos de react native se realizaron las apps{" "}
        <a href='https://bitbucket.org/4rsoluciones/swc/src/master/'>SWC</a> y{" "}
        <a href='https://bitbucket.org/4rsoluciones/cqv-pasajero/src/master/'>
          CQV Pasajero
        </a>
        .
      </p>
    </Container>
  );
};

export default new Content({
  Component: NativeModules,
  title: "Native Modules",
  route: "native-modules",
  tags: [
    "react",
    "react-native",
    "native",
    "module",
    "ios",
    "android",
    "mobile",
    "app",
    "bluetooth",
    "os",
    "swift",
    "objective",
    "java",
    "kotlin",
    "geocoding",
    "calendar",
    "machine",
    "learning"
  ]
});
